
import qs from 'qs'
import Axios from 'axios'

const env = process.env
let token = window.localStorage.getItem('token') || ''
let jurisdiction = JSON.parse(window.localStorage.getItem('jurisdiction')) || []

// 设置baseURL
Axios.defaults.baseURL = process.env.API_HOST
// 设置token值
// Axios.defaults.headers.common['token'] = token
// 请求头
Axios.defaults.headers.post['Content-Type'] = 'application/json'

// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
//   if (config.method !== 'get' && config.method !== 'delete' && config.url.indexOf('/tvpver/add') === -1 && config.url.indexOf('/tvp/add') === -1 && config.url.indexOf('/tvp/edit') === -1 && config.url.indexOf('/file') === -1) {
//     config.data = qs.stringify(config.data)
//   }
    if(config.method == 'post'){
        config.params = qs.stringify(config.params)
    }
  return config
}, function (error) {
  // 对请求错误做些什么
  console.log('错误的传参',errpr)
  return Promise.reject(error)
})

// 添加响应拦截器
// Axios.interceptors.response.use(function (response) {
//   // 对响应数据做点什么
//   return response;
// }, function (error) {
//   // 对响应错误做点什么
//   return Promise.reject(error);
// });

function request (data) {
  return new Promise((resolve, reject) => {
    Axios({
      method: data.method,
      url: data.url,
      params: data.params,
      data: data.data,
      headers: data.headers
    }).then(res => {
      // if (res.data.code === 0) {
        resolve(res.data)
      // } else if (res.data.code === 401) {
      //   window.localStorage.removeItem('token')
      //   window.localStorage.removeItem('username')
      //   window.localStorage.removeItem('userId')
      //   window.localStorage.removeItem('role_id')
      //   location.reload()
      // } else {
      //   reject(res.data.msg)
      // }
    }).catch(error => {
      console.log('请求失败')
      console.log(error)
    })
  })
}


export default {
  env,
  token,
  jurisdiction,
  config: {},
  request
}



// WEBPACK FOOTER //
// ./src/https.js